import { Injectable } from "@angular/core";
import { InsightSavedCriteria, InsightSavedResponse, ServiceResponse } from "@appcore/data";
import { Observable } from "rxjs";
import { API } from "@service/system/api.service";
import { HttpManager } from "@service/system/httpManager.service";
import { ResponseHandler } from "../system/responseHandler.service";

const API_URL = API.API_URL;

@Injectable()
export class InsightsSavedCriteriaService {
	private _insightsURL = API_URL + "/insights";

	constructor(private httpManager: HttpManager, private responseHandler: ResponseHandler) {}

	getUserInsightsSavedCriteria(userId: string): Observable<ServiceResponse<InsightSavedCriteria[]>> {
		return this.responseHandler.httpGet<InsightSavedCriteria[]>(`${this._insightsURL}/savedinsights/user/${userId}`);
	}

	getSavedInsightCriteria(insightId: string): Observable<ServiceResponse<InsightSavedCriteria[]>> {
		return this.responseHandler.httpGet<InsightSavedCriteria[]>(`${this._insightsURL}/savedinsights/insight/${insightId}`);
	}

	deleteSavedInsightCriteria(insightId: string): Observable<InsightSavedResponse> {
		return this.httpManager.httpDelete<InsightSavedResponse>(`${this._insightsURL}/savedinsights/${insightId}`, {});
	}

	setSavedInsightCriteria(insightId: string, body: InsightSavedCriteria): Observable<InsightSavedResponse> {
		return this.httpManager.httpPost<InsightSavedResponse>(`${this._insightsURL}/savedinsights/${insightId}`, body);
	}
}
